export function scrollTo(elementId?: string) {
	if (elementId) {
		const element = document.getElementById(elementId);
		if (element) {
			element.scrollTo({
				top: 0,
				behavior: 'smooth',
			});
		}
	}

	window.scrollTo({
		top: 0,
		behavior: 'smooth',
	});
}

export function scrollToFirstErrorMessage() {
	setTimeout(() => {
		const element = document.querySelector('.error-message');
		if (element) {
			const parentElement = element.parentElement;
			if (parentElement) {
				parentElement.scrollIntoView({
					behavior: 'smooth',
					block: 'center',
					inline: 'nearest',
				});
			}
		}
	}, 200);
}

/**
 * Scrolls to an element with smart offset handling.
 * Only applies offset when scrolling upward (from bottom to top),
 * allowing natural scrolling when going downward.
 *
 * @param elementId - The ID of the element to scroll to
 * @param offset - The offset in pixels to apply when scrolling upward (default: 96)
 */
export function scrollToAnchorWithOffset(
	elementId: string,
	offset: number = 96,
): void {
	const element = document.getElementById(elementId);
	if (!element) return;

	const currentScrollY = window.scrollY;
	const elementTop = element.getBoundingClientRect().top + currentScrollY;
	const isScrollingUp = currentScrollY > elementTop;

	// Only apply offset when scrolling upward (from bottom to top)
	const scrollOffset = isScrollingUp ? offset : 0;

	window.scrollTo({
		top: elementTop - scrollOffset,
		behavior: 'smooth',
	});
}
